module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_mail-e882471ec5a82d52e2641e1c10b6bcaf.svg";